

export const version = "V 12.0.32";
export const versionDate = "July 23, 2026 4:51 AM EDT";
export const versionNotes = "White Board flipped pages, default defence preset, and page editor updates";

export const getScoutReports = async (playerID, user) => {
    const API_ENDPOINT = "https://www.fbxchange.com/ReactPHP/scoutreports.php"; // unchanged
    const res = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            scriptName: "getReports",
            ID: playerID,
            scout: user.scout,
            team: user.team || "",
        }),
    });
    const resp = await res.json();
    return resp;
};

export const getOneScoutReport = (reportID, user) => {
    return `scoutReport_${reportID}`;
}
